"use strict";
/* eslint-disable no-shadow */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerStatuses = exports.GovernmentTypes = exports.CustomerTypes = void 0;
var CustomerTypes;
(function (CustomerTypes) {
    CustomerTypes["CITY"] = "city";
    CustomerTypes["COUNTY"] = "county";
    CustomerTypes["STATE_AGENCY"] = "state";
    CustomerTypes["LAW_ENFORCEMENT_AGENCY"] = "law";
    CustomerTypes["OTHER"] = "other";
})(CustomerTypes = exports.CustomerTypes || (exports.CustomerTypes = {}));
var GovernmentTypes;
(function (GovernmentTypes) {
    GovernmentTypes["MAYOR_COUNCIL"] = "mayor-council";
    GovernmentTypes["COUNCIL_MANAGER"] = "council-manager";
})(GovernmentTypes = exports.GovernmentTypes || (exports.GovernmentTypes = {}));
var CustomerStatuses;
(function (CustomerStatuses) {
    CustomerStatuses["ACTIVE"] = "active";
    CustomerStatuses["INACTIVE"] = "inactive";
    CustomerStatuses["DEMO"] = "demo";
    CustomerStatuses["TEST"] = "test,";
})(CustomerStatuses = exports.CustomerStatuses || (exports.CustomerStatuses = {}));
